import kebabCase from '@/utils/kebabCase';

const isUrl = (url: string) => {
  try {
    new URL(url);

    return true;
  } catch (_) {
    return false;
  }
};

interface IconProps {
  name: string;
  classes: string;
}

export const Icon = (props: IconProps) => {
  if (!props.name) {
    return null;
  }
  if (isUrl(props.name)) {
    return <img src={props.name} class={props.classes} />;
  }
  try {
    const iconName = `${kebabCase(props.name)}`;
    const iconSvgSrc = `https://unpkg.com/@phosphor-icons/core@2.0.2/assets/regular/${iconName}.svg`;

    return (
      <img crossorigin="anonymous" src={iconSvgSrc} class={props.classes} />
    );
  } catch (e) {
    console.error(e);

    return null;
  }
};
